import { IIndustryMast } from "../../models/IndustryMast";

export const EmptyIndustry:IIndustryMast ={
    industry_Name :"",
    industry_Id :0,
    description:"",
    
}